module.exports = __webpack_public_path__ + "img/image3.4fc1808a.jpg";